module.exports = __webpack_public_path__ + "img/point_to.b9f26697.svg";